import { getKrPp } from '@js-dot/text';
const KoreanPostPosition = {
  pattern: /^[을를이가은는로과와]$/,
  transform(word, args) {
    const ppWord = word.replace(/[oe]r$/, '어');
    return word + getKrPp(ppWord, args[0]);
  }
};

/**
 * Generated bundle index. Do not edit.
 */

export { KoreanPostPosition };
